import PropTypes from "prop-types";
import React from "react";
import {
    Grid,
    Image,
} from "semantic-ui-react";
import photoPlaceholder from "./placeholder.jpg";
import Counters from "./util/Counters";
import Markdown from "./util/Markdown";
import Timestamp from "./util/Timestamp";
import withDocumentReference from "./util/withDocumentReference";
import User from "./util/User";

class Submission extends React.PureComponent {

    render() {
        const {
            submission: s,
            creator,
            media,
            index,
        } = this.props;
        return <Grid.Row style={index % 2 === 0 ? {} : {
            backgroundColor: "#f7f7f7",
        }}>
            <Grid.Column width={4}
                         textAlign="center">
                {s.counters
                    ? <Counters delta
                                n={s.counters} />
                    : media
                        ? <a href={media.downloadURL}
                             target="_blank">
                            <Image fluid
                                   src={(media.thumbnail && media.thumbnail.downloadURL) || photoPlaceholder}
                                   alt={media.name}
                            />
                        </a>
                        : ""}
            </Grid.Column>
            <Grid.Column width={12}>
                <Timestamp ts={s.createdAt} />
                {" "}
                {creator && <User user={creator} />}
                {" "}
                {s.notes
                    ? <Markdown text={s.notes} />
                    : media
                        ? <p>{media.name}</p>
                        : ""}
            </Grid.Column>
        </Grid.Row>;
    }
}

Submission.propTypes = {
    submission: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
};

export default withDocumentReference({
    media: props => props.submission && props.submission.media,
    creator: props => {
        if (! props.submission || !props.submission.creator) {
            // no data
            return;
        }
        let creator = props.submission.creator;
        return props.me === creator.id ? null : creator;
    },
})(Submission);



// WEBPACK FOOTER //
// ./src/Submission.js